import { BreakpointObserver, BreakpointState } from '@angular/cdk/layout';
import { Location } from '@angular/common';
import { Component, OnInit } from '@angular/core';
import { Router, NavigationEnd } from '@angular/router';
import { Observable } from 'rxjs';
import { filter } from 'rxjs/operators';
import { NotificacoesService } from 'src/app/notificacoes/notificacoes.service';
import { AutenticacaoService } from 'src/app/seguranca/autenticacao.service';
import { Bandeira } from 'src/app/shared/models/bandeira.enum';
import { Notificacao } from 'src/app/shared/models/notificacao.model';
import { GoogleAnalyticsService } from 'src/app/shared/services/google-analytics.service';
import { ToastService } from 'src/app/shared/toast';
import BrowserUtils from 'src/app/shared/utils/browser-utils';

@Component({
  selector: 'app-internal-header',
  templateUrl: './internal-header.component.html',
  styleUrls: ['./internal-header.component.scss']
})
export class InternalHeaderComponent implements OnInit {

  private readonly CB_WHATS_APP_URL = 'https://wa.me//551126265190?text=Oi%20'
  private readonly PF_WHATS_APP_URL = 'https://wa.me//551131360845?text=Oi%20'

  isCasasBahia = this.autenticacaoService.bandeira === Bandeira.CASAS_BAHIA;
  isMinorThanTablet: Observable<BreakpointState> = this.breakpointObserver.observe('(max-width: 768px)');
  notifications: Notificacao[] = [];
  isHomePage: boolean = false;

  isWebView = BrowserUtils.isWebView();

  constructor(
    public breakpointObserver: BreakpointObserver,
    public autenticacaoService: AutenticacaoService,
    public notificacaoService: NotificacoesService,
    public toastService: ToastService,
    public router: Router,
    public Location: Location,
    public googleAnalyticsService: GoogleAnalyticsService,
  ) { }

  ngOnInit(): void {
    this.isHomePage = true;
    this.router.events
      .pipe(filter((event) => event instanceof NavigationEnd))
      .subscribe(() => {
        this.isHomePage = this.router.url === "/portal";
      });
    this.fetchNotifications();
  }

  handleGoBack() {
    this.Location.back();
  }

  async fetchNotifications(): Promise<void> {
    try {
      this.notifications = await this.notificacaoService.getNotificacoes();
    } catch (response) {
      if (response && response.error) {
        this.toastService.show({
          title: 'Erro ao buscar notificações.',
          type: 'error',
          text: response.error.mensagem
        })
      } else {
        this.toastService.show({
          title: 'Erro ao buscar notificações.',
          type: 'error',
          text: 'Por favor tente novamente mais tarde.'
        })
      }
    }
  }

  get totalUnviewedNotifications(): number {
    return this.notifications.filter((notificacao) => !notificacao.visualizado).length;
  }

  get totalNotifications(): number {
    return this.notifications.length;
  }

  async markNotificationsAsRead(): Promise<void> {
    this.googleAnalyticsService.pushActionEvent({
      event: 'click',
      detail: 'notificacoes',
      context: 'portal reneg:portal'
    })

    for (const notification of this.notifications) {
      if (!notification.visualizado) {
        await this.notificacaoService.marcarComoLida(notification.id);
      }
    }
  }

  logout(): void {
    this.googleAnalyticsService.pushActionEvent({
      event: 'click',
      detail: 'sair',
      context: 'portal reneg:portal'
    })
    if (this.autenticacaoService.temColaboradorAutenticado()) {
      this.autenticacaoService.logoutCliente();
      this.router.navigate(['/auth/colaborador']);
    } else {
      this.autenticacaoService.logout();
      this.router.navigate(['']);
    }
  }

  get hasAuthenticatedEmployee(): boolean {
    return this.autenticacaoService.temColaboradorAutenticado();
  }

  get whatsAppUrl() {
    return this.isCasasBahia ? this.CB_WHATS_APP_URL : this.PF_WHATS_APP_URL
  }

  goToProfilePage() {
    this.googleAnalyticsService.pushActionEvent({
      event: 'click',
      detail: 'meu cadastro',
      context: 'portal reneg:portal'
    })
    this.router.navigate(['/portal/perfil']);
  }

  goToHome() {
    if (!this.isHomePage) {
      this.googleAnalyticsService.pushActionEvent({
        event: 'click',
        detail: 'carne e cartao',
        context: 'portal reneg:portal'
      });
      this.router.navigate(['/portal']);
    }
  }

  get isAutoLogin() {
    return this.autenticacaoService.isAutoLogin;
  }

  get username() {
    return this.autenticacaoService?.autenticacao?.nomeCliente ?? '';
  }

  handleGaEvent() {
    this.googleAnalyticsService.pushActionEvent({
      event: 'click',
      detail: 'atendimento whatsApp',
      context: 'portal reneg:portal'
    });
  }
}
